
import Vue from 'vue'
import { RButton } from '@/components'
import { UsualObject } from '@/services/objects'

type BannerState = {
  shown: boolean
}

export default Vue.extend({
  name: 'BaseBanner',
  components: {
    RButton,
  },
  props: {
    closingX: {
      type: Boolean,
      default: true,
    },
  },
  data(): BannerState {
    return {
      shown: true,
    }
  },
  computed: {
    styles(): UsualObject {
      let styles: UsualObject = {}
      // to consider close button, if present
      if (this.closingX) {
        styles.paddingRight = '40px'
      }
      return styles
    },
  },
})
